// eslint-disable-next-line max-lines
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import moment from 'moment'
import ReactTable from 'react-table'
import { Form, message, Tooltip } from 'antd'
import Loader from '../../util/Loader'
import history from '../../history'
import { actions as leadContractActions } from '../../redux/modules/leadFunctions/leadContractActions'
import { actions as contractActions } from '../../redux/modules/contractActions'
import { actions as leadProposalActions } from '../../redux/modules/leadFunctions/leadProposalActions'
import { actions as contractTemplateActions } from '../../redux/modules/leadFunctions/contractTemplateActions'
import { actions as leadDetails } from '../../redux/modules/leadDetails'
import { actions as revisionActions } from '../../redux/modules/revisionActions'
import { filterCaseInsensitive } from '../../util'
import { ModalRoute } from 'react-router-modal'
import _ from 'lodash'

import CreateJobForm from './components/CreateJobForm'
import AddEditFormModal from './components/contracts/AddEditFormModal.component'

import * as authSelectors from '../../selectors/auth'
import * as contractsSelectors from '../../selectors/lead/contracts'

const propTypes = {}
class LeadContracts extends Component {
  state = {
    contentData: null
  }

  componentDidMount() {
    this.props.leadContractRefresh({
      leadId: this.props.leadId,
      next: (err, payload) => {
        const { contractId } = this.props
        if (contractId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: parseInt(contractId, 10) })
            this.setState({
              contentData: current
            })

            this.props.getRevisions({
              targetId: contractId,
              table: 'contract'
            })
            // get atttachments
            this.props.getAttachments({ contractId: contractId })

            // get payment schedules
            this.props.getContractPaymentSchedule({ contractId: contractId })
          }
        }
      }
    })
    this.props.leadProposalsRefresh({
      leadId: this.props.leadId
    })
    this.props.fetchContracts({
      leadId: this.props.leadId
    })
    this.props.getContractTemplates()
  }

  handleToggleCreateJobForm = () => {
    this.setState({
      modalCreateJobVisible: !this.state.modalCreateJobVisible,
      contractId: null
    })
  }

  handleOpenCreateJobForm = contractId => {
    this.setState({
      modalCreateJobVisible: !this.state.modalCreateJobVisible,
      contractId
    })
  }

  handleCreateJob = params => {
    params.updated_by_id = this.props.user.userId
    params.created_by_id = this.props.user.userId
    params.assigned_to_id = this.props.user.userId
    this.props.createJobFromLead({
      leadId: this.props.match.params.leadId,
      content: params
    })

    message.success('Job Created!')
    this.handleToggleCreateJobForm(null)
  }

  handleRowClick = row => {
    const { leadId } = this.props
    this.props.getRevisions({
      targetId: row.id,
      table: 'contract'
    })
    // get atttachments
    this.props.getAttachments({ contractId: row.id })

    // get payment schedules
    this.props.getContractPaymentSchedule({ contractId: row.id })

    this.setState(
      {
        contentData: row
      },
      () => {
        history.push(`/lead/${leadId}/contracts/edit/${row.id}`)
      }
    )
  }

  handleAddButton = () => {
    const { leadId } = this.props
    history.push(`/lead/${leadId}/contracts/add`)
    this.setState({
      contentData: null
    })
  }

  handleSetContentData = contentDataNew => {
    this.setState({
      contentData: contentDataNew
    })
  }

  render() {
    const { contentData } = this.state
    const { leadId, contractId, contracts } = this.props

    if (!this.props.leadContractActions.leadContracts) {
      return <Loader />
    }
    return (
      <div>
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'add',
            leadId: leadId,
            handleSetContentData: this.handleSetContentData
          }}
          path={`/lead/:leadId/contracts/add`}
          exact
        />
        <ModalRoute
          component={AddEditFormModal}
          props={{
            action: 'edit',
            leadId: leadId,
            contentData: contentData,
            contractId: contractId,
            handleSetContentData: this.handleSetContentData
          }}
          path={`/lead/:leadId/contracts/edit/:contractId`}
          exact
        />
        <CreateJobForm
          contracts={contracts}
          modalVisible={this.state.modalCreateJobVisible}
          handleCreateJob={this.handleCreateJob}
          handleToggleCreateJobForm={this.handleToggleCreateJobForm}
          contractId={contractId}
        />
        <div className="jobsBar">
          Contracts
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Contract
            </div>
          </div>
        </div>
        {this.props.leadContractActions.leadContracts && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: e => {
                if (column.Header !== 'Create Job') {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={this.props.leadContractActions.leadContracts.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'ID',
                    accessor: 'id',
                    maxWidth: 100
                  },
                  {
                    Header: 'Proposal ID',
                    id: 'proposal_id',
                    accessor: 'proposal_id',
                    Cell: d => (
                      <Link
                        to={{ path: `#` }}
                        onClick={() =>
                          this.props.handleShortcut('Lead Proposals', d.original.proposal_id)
                        }
                      >
                        {d.original.proposal_id}
                      </Link>
                    ),
                    maxWidth: 150
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    ),
                    minWidth: 200
                  },
                  {
                    Header: 'Status',
                    id: 'status',
                    accessor: 'status',
                    Cell: d => {
                      return <Tooltip title={d.original.status}>{d.original.status}</Tooltip>
                    },
                    maxWidth: 110
                  },
                  {
                    Header: 'Create Job',
                    id: 'create_job',
                    accessor: 'create_job',
                    Cell: d => {
                      if (d.original.signed) {
                        return (
                          <Link
                            to={{ path: `#` }}
                            onClick={() => this.handleOpenCreateJobForm(d.original.id)}
                          >
                            Create Job
                          </Link>
                        )
                      } else {
                        return 'Not Signed'
                      }
                    },
                    maxWidth: 120
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY'),
                    maxWidth: 110
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  leadContractActions: state.leadContractActions,
  contractTemplate: state.contractTemplate,
  leadProposalActions: state.leadProposalActions,
  leadDetails: state.leadDetails,
  contractActions: state.contractActions,
  revisionActions: state.revisionActions,
  user: authSelectors.getUser(state, props),
  contractId: contractsSelectors.getContractIdParam(state, props),
  contracts: contractsSelectors.getContracts(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      leadContractActions,
      contractTemplateActions,
      leadProposalActions,
      leadDetails,
      contractActions,
      revisionActions
    ),
    dispatch
  )
})

LeadContracts.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(LeadContracts))
)



// WEBPACK FOOTER //
// ./src/pages/lead/LeadContracts.container.js